import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-544ed6a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "usage-rate-wrap" }
const _hoisted_2 = { class: "usable-capacity" }
const _hoisted_3 = { class: "total-capacity" }
const _hoisted_4 = { class: "value" }

import { computed } from 'vue'
import RatePie from '@/views/dashboard/_components/rate-pie/rate-pie.vue'

/** 告警红（echarts/canvas 无法解析 CSS 变量，只能用具体色值） */
const ALARM_COLOR = '#E54545' // dm-keep


export default /*#__PURE__*/_defineComponent({
  __name: 'usage-rate',
  props: {
  used: {
    type: Number,
    default: 0
  },
  all: {
    type: Number,
    default: 0
  },
  title: {
    type: String,
    default: ''
  },
  alarmRate: {
    type: Number,
    default: 95,
  },
  unit: {
    type: String,
    default: '%',
  },
},
  setup(__props) {

const props = __props

const percentage = computed(() => {
  if (!props.all) {
    return 0
  }

  return Math.floor(props.used / props.all * 100)
})

const isAlarm = computed(() => {
  return percentage.value > props.alarmRate
})

const usable = computed(() => {
  return +(props.all - props.used).toFixed(2)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RatePie, {
      class: "rate-pie",
      title: __props.title,
      value: percentage.value,
      color: isAlarm.value ? ALARM_COLOR : '',
      "shadow-color": isAlarm.value ? '#F0F0F0' : '#E4ECF4'
    }, null, 8, ["title", "value", "color", "shadow-color"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('runStatus.unused')), 1),
      _createElementVNode("span", {
        class: _normalizeClass(["value", { 'is-alarm': isAlarm.value }])
      }, _toDisplayString(usable.value), 3),
      _createElementVNode("span", null, _toDisplayString(__props.unit), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('runStatus.totalCapacity')), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.all.toFixed()), 1),
      _createElementVNode("span", null, _toDisplayString(__props.unit), 1)
    ])
  ]))
}
}

})